import React, { Component } from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import moment from 'moment';
import PropTypes from 'prop-types';

import { VFText, Icon } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { DateCurrencyFromatter } from '@vfgroup-oneplatform/foundation/Utils';

import FrameworkTestKeys from '../../../FrameworkTestKeys';
import { Item_Types } from '../../Utils/ItemsTypes.Enum';

import styles from './BalanceItem.Styles';

class BalanceItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      theme,
      icon,
      iconSize,
      title,
      date,
      duration,
      price,
      type,
      images,
      recurring,
      containerStyle,
      transactionStatus,
    } = this.props;

    const { dateFormats, dateTransformer, currencyTransformer } =
      DateCurrencyFromatter.dateCurrencyFromatter;

    return (
      <View
        style={[styles.containerStyle(theme), containerStyle]}
        testID={FrameworkTestKeys.balanceItemComponentView}
      >
        <View
          style={styles.balanceIconViewStyle}
          testID={FrameworkTestKeys.balanceItemComponentIconView}
        >
          <Icon
            name={images[icon]}
            type="image"
            size={iconSize > 34 ? 34 : iconSize}
            testID={FrameworkTestKeys.balanceItemComponentIcon}
          />
        </View>
        <View
          style={styles.itemDataViewStyle}
          testID={FrameworkTestKeys.balanceItemComponentItemDataView}
        >
          <View
            style={styles.balanceDataViewStyle}
            testID={FrameworkTestKeys.balanceItemComponentBalanceDataView}
          >
            <VFText
              style={styles.balanceTitleStyle(theme)}
              i18nKey={title}
              testKey={FrameworkTestKeys.balanceItemComponentTitleText}
            />
            <VFText
              style={styles.balanceItemDate(theme)}
              i18nKey={
                moment(date).month() === moment().month()
                  ? dateTransformer(date, dateFormats.timeStampCapital)
                  : dateTransformer(date, dateFormats.default)
              }
              testKey={FrameworkTestKeys.balanceItemComponentDate}
            />
          </View>
          {(type === Item_Types.LOCAL_CALLS || type === Item_Types.ITERNATIONAL_CALLS) && (
            <View
              style={styles.rightblock}
              testID={FrameworkTestKeys.balanceItemComponentCallsRightBlockView}
            >
              <VFText
                style={styles.balanceItemPrice(theme)}
                i18nKey={currencyTransformer(price, 0)}
                testKey={FrameworkTestKeys.balanceItemComponentCallsPrice}
              />

              <VFText
                style={styles.balanceItemDate(theme)}
                i18nKey={duration}
                testKey={FrameworkTestKeys.balanceItemComponentCallsDuration}
              />
            </View>
          )}
          {type === Item_Types.TOP_UP && (
            <View
              style={styles.rightblock}
              testID={FrameworkTestKeys.balanceItemComponentTopUpRightBlockView}
            >
              <VFText
                style={styles.balanceItemPriceTopUp(theme)}
                i18nKey={currencyTransformer(price, 0)}
                testKey={FrameworkTestKeys.balanceItemComponentTopUpPrice}
              />
              {!!transactionStatus && (
                <VFText
                  style={styles.balanceItemDate(theme)}
                  i18nKey={transactionStatus}
                  testKey={FrameworkTestKeys.balanceItemComponentTopUpStatus}
                />
              )}
            </View>
          )}
          {type === Item_Types.ADDONS && (
            <View
              style={styles.rightblock}
              testID={FrameworkTestKeys.balanceItemComponentAddonsRightBlockView}
            >
              <VFText
                style={styles.balanceItemPrice(theme)}
                testKey={FrameworkTestKeys.balanceItemComponentAddonsPrice}
              >
                {currencyTransformer(price, 0)}
              </VFText>
              {recurring ? (
                <VFText
                  style={styles.balanceItemDate(theme)}
                  i18nKey={'add_data_occurrence_second_option_title'}
                  testKey={FrameworkTestKeys.balanceItemComponentAddonsRecurringSecondOption}
                />
              ) : (
                <VFText
                  style={styles.balanceItemDate(theme)}
                  i18nKey={'add_data_occurrence_first_option_title'}
                  testKey={FrameworkTestKeys.balanceItemComponentAddonsRecurringFirstOption}
                />
              )}
            </View>
          )}
        </View>
      </View>
    );
  }
}

BalanceItem.defaultProps = {
  iconSize: 34,
  theme: LightThemeColors,
};
BalanceItem.propTypes = {
  title: PropTypes.string,
  date: PropTypes.string,
  duration: PropTypes.string,
  price: PropTypes.string,
  type: PropTypes.string,
  recurring: PropTypes.bool,
  icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      uri: PropTypes.string.isRequired,
    }),
  ]).isRequired,
  iconSize: PropTypes.number,
  images: PropTypes.object,
  containerStyle: ViewPropTypes.style,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  transactionStatus: PropTypes.string,
};
export default withTheme(BalanceItem);
